export default "__VITE_ASSET__e082ddad__"